import { render } from "./LangPrefs.vue?vue&type=template&id=1415c4f3&scoped=true&ts=true"
import script from "./LangPrefs.vue?vue&type=script&lang=ts"
export * from "./LangPrefs.vue?vue&type=script&lang=ts"

import "./LangPrefs.vue?vue&type=style&index=0&id=1415c4f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1415c4f3"]])

export default __exports__